module.exports = __webpack_public_path__ + "static/media/03.d583caaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/volumetric/makeup/03.png
// module id = 636
// module chunks = 0